import BaseModel from './BaseModel';

export class ForumLiker extends BaseModel {
  static get entity() {
    return 'forum_likers';
  }

  static fields() {
    return {
      id: this.attr(null),
      forum: this.attr(null),
      forum_thread: this.attr(null),
      user: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    };
  }
}

export default ForumLiker;
